$(document).ready(function() {

   if(!$('body').hasClass('.mini-cart--open')) { 
    setTimeout(function() {
      
       var cartDrawerShipping = $('form#cart .w-full.bg-washedGreen').html();
        $('main#MainContent .w-full.bg-washedGreen').html(cartDrawerShipping);

        var data_price = Number($('.free-shipping .free-shipping__text').attr("data-price"));
        var step5 = Number($('.collection__free-shipping-bar .free-shipping__progress .progress_steps').attr("data-surprise"));

        var step1 = Number($('.progress_steps span#step1').attr("data-shipping"));
        var step2 = Number($('.progress_steps span#step2').attr("data-gift"));
        var step3 = Number($('.progress_steps span#step3').attr("data-discount"));
        var step4 = Number($('.progress_steps span#step4').attr("data-surprise"));

        // if (data_price <= step1) {
        //     var shipping_total = step1 - data_price;
        //     var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + shipping_total + '</strong> to get <strong> free worldwide shipping </strong> </span>';
        //     $('.free-shipping .free-shipping__text').html(appendHtml);
        // } else if (data_price <= step2) {
        //     var gift_total = step2 - data_price;
        //     var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + gift_total + '</strong> to unlock your next surprise</span>';
        //     $('.free-shipping .free-shipping__text').html(appendHtml);
        // } else if (data_price <= step3) {
        //     var discount_ = step3 - data_price;
        //     var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + discount_ + '</strong> to unlock your next surprise</span>';
        //     $('.free-shipping .free-shipping__text').html(appendHtml);
        // } else if (data_price <= step4) {
        //     var surprise = step4 - data_price;
        //     var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + surprise + '</strong> to unlock your next surprise</span>';
        //     $('.free-shipping .free-shipping__text').html(appendHtml);
        // } else if (data_price > step5) {
        //     console.log("load congrats");
        // } 
    }, 2500);
  }else{
 // console.log('Stopped counting');
} 
    /*---Shipping progress Start---*/

function addToteBag(){
    var varid = 44163889987879; 
    var Items = {
        "id": varid,
        "quantity": 1
    }
    setTimeout(function() {
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: Items,
          dataType: 'json', 
          success: function(stuff) {
              if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) {} else {
                  // var html = '<li class="addProduct" data-variant-id="44034678784295" data-handle="tote-bag-not-for-sale"><div class="product-container"><div><a href="/products/tote-bag-test-not-for-sale?variant=44034678784295" class="product-image media-wrapper media-wrapper--small"><lazy-image class="media media--adapt" style="--image-ratio-percent: 125.0%;"><img srcset="https://cdn.shopify.com/s/files/1/1162/8602/products/pexels-stephanie-ho-1214212.jpg?v=1669357639&width=70" src="https://cdn.shopify.com/s/files/1/1162/8602/products/pexels-stephanie-ho-1214212.jpg?v=1669357639&width=70" alt="" width="70" height="88" loading="lazy"></lazy-image></a></div><div class="product-description"><div class="product-content"><a href="/products/tote-bag-test-not-for-sale?variant=44034678784295" class="link product-title">Tote Bag Test not for sale</a><p class="cart-item__error form__message errors" id="Line-item-error-1"><span class="cart-item__error-text"></span></p></div></div></div></li>';
                     var html = '<li class="addProduct" data-variant-id="44163889987879" data-handle="free-gift-large-tote-bag"><div class="product-container"><div><a href="/products/free-gift-large-tote-bag?variant=44163889987879" class="product-image media-wrapper media-wrapper--small"><lazy-image class="media media--adapt" style="--image-ratio-percent: 100.0%;"><img srcset="//cdn.shopify.com/s/files/1/1162/8602/products/Totebaggift_1of1_4f75d6f5-1950-49a1-9aaa-ecfd021ef25b.jpg?v=1671712511&amp;width=70 1x, //cdn.shopify.com/s/files/1/1162/8602/products/Totebaggift_1of1_4f75d6f5-1950-49a1-9aaa-ecfd021ef25b.jpg?v=1671712511&amp;width=140 2x" src="//cdn.shopify.com/s/files/1/1162/8602/products/Totebaggift_1of1_4f75d6f5-1950-49a1-9aaa-ecfd021ef25b.jpg?v=1671712511&amp;width=70" alt="" width="70" height="70" loading="lazy"></lazy-image></a></div><div class="product-description"><div class="product-content"><a class="link product-title">Free gift - Large Tote Bag</a><p class="cart-item__error form__message errors" id="Line-item-error-2"><span class="cart-item__error-text"></span></p></div></div></div></li>'; 
                $('cart-items ul.mini-cart__navigation').append(html);
              }
          },
          error: function(stuff) { }
        });
    }, 50);
}
function removeToteBag(){
         var RemoveItems = {
            "id": 44163889987879,
            "quantity": 0
         }
    setTimeout(function() {
        jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: RemoveItems,
            dataType: 'json',
            success: function(stuff) {
                console.log('step-1500-freeshipping-only');
                $('.addProduct[data-variant-id="44163889987879"]').remove();
               $.ajax({
                    type: 'GET',
                    dataType: 'json',
                    url: '/cart.json',
                    success: function(cart){
                        // Remove item
                      setTimeout(function(){
                        $('cart-items ul.mini-cart__navigation').parents('li[data-variant-id="44163889987879"]').remove();
                      },1500);  
                    }
               });
            },
            error: function(stuff) { }
        });
    }, 50);
}
function updateToteBag(){
  var varid = 44163889987879; 
    var Items = {
        "id": varid,
        "quantity": 1
    }
    setTimeout(function() {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: Items,
      dataType: 'json',
      success: function(stuff) {
            console.log('updateToteBag');  
      },
      error: function(stuff) { }
    });
    }, 100);
}
function addSurpriseGift(){
        var Items = {
        "id": 44163896410407,
        "quantity": 1
        }   
    setTimeout(function() {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: Items,
        dataType: 'json',
        success: function(stuff) {
            console.log(stuff);
            if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) {} else {
                var Html = '<li class="addProduct" data-variant-id="44163896410407" data-handle="test-not-for-sale-surprise-product"><div class="product-container"><div><a href="/products/test-not-for-sale-surprise-product?variant=44163896410407" class="product-image media-wrapper media-wrapper--small"><lazy-image class="media media--adapt" style="--image-ratio-percent: 114.17835671342684%;"><img srcset="//cdn.shopify.com/s/files/1/1162/8602/products/gift-img_9bdc0083-8a2e-41da-8e47-6778fc2652b1.jpg?v=1671712815&amp;width=70 1x, //cdn.shopify.com/s/files/1/1162/8602/products/gift-img_9bdc0083-8a2e-41da-8e47-6778fc2652b1.jpg?v=1671712815&amp;width=140 2x" src="//cdn.shopify.com/s/files/1/1162/8602/products/gift-img_9bdc0083-8a2e-41da-8e47-6778fc2652b1.jpg?v=1671712815&amp;width=70" alt="" width="70" height="80" loading="lazy"></lazy-image></a></div><div class="product-description"><div class="product-content"><a class="link product-title">Test not for sale Surprise Product</a><p class="cart-item__error form__message errors" id="Line-item-error-1"><span class="cart-item__error-text"></span></p></div></div></div></li>'; 
       $('cart-items ul.mini-cart__navigation').append(Html);
            }
        },
        error: function(stuff) {  }
    });
    }, 50);
}
function removeSurpriseGift(){
    var Items = {
        "id": 44163896410407,
        "quantity": 0
    }
    setTimeout(function() {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: Items,
        dataType: 'json',
        success: function(stuff) {
            console.log('surprise remove');
            $('.addProduct[data-variant-id="44163896410407"]').remove();
        },
        error: function(stuff) { }
    });
    }, 50);
}
function updateSurpriseGift(){
    var Items = {
        "id": 44163896410407,
        "quantity": 1
    }
    setTimeout(function() {
    jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: Items,
        dataType: 'json',
        success: function(stuff) {
            console.log('surprise Update'); 
        },
        error: function(stuff) { }
    });
    }, 100);
}
  // updateSurpriseGift();
  // updateToteBag();

$(document).on('click', '.product-form__submit , cart-remove-button , .mini-cart__navigation .quantity__button', function(){
  
  $('body').removeClass('barDisconnect');
    setTimeout(function(){
      $('body').removeClass('barDisconnect');
    },2000);
})

  
function shippingBarStatus() {
  
  if($(document).find('.barDisconnect').length){}else{
       var cartDrawerShipping = $('form#cart .w-full.bg-washedGreen').html();
        $('main#MainContent .w-full.bg-washedGreen').html(cartDrawerShipping);
      
        var total = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total"));
        setTimeout(function() {
            var total = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total")); 
            console.log(total);
           // if ($('body').hasClass('progressDone')) { } else {
                var step1 = Number($('.progress_steps span#step1').attr("data-shipping"));
                var step2 = Number($('.progress_steps span#step2').attr("data-gift"));
                var step3 = Number($('.progress_steps span#step3').attr("data-discount"));
                var step4 = Number($('.progress_steps span#step4').attr("data-surprise"));

 /*-----------------------Step 1 - Free Shipping Calculation -------------------------------*/
                if (total <= step1) {

                    console.log(total + ' step1 ' + step1)
                    var productId = $(".gift_product-id").attr('id'); 
                    var shipping_total = step1 - total;
                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add a hat <strong>' + shipping_total + '</strong> Gets free shipping added automatically</span>';
                    // $('.free-shipping .free-shipping__text').html(appendHtml);
                    var x = (step1 * 100) / step4;
                 //$('.progress_steps #step1').css("width", +25 + '%'); 
                 
                    if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) {
                         removeToteBag();
                    } 
                    if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) {
                         removeSurpriseGift();
                    }   
                  

                    
 /*----------------------- Step 2 Apply Shipping and Bag Calculation ---------------------------------*/
                  } else if (total <= step2) {
                    // remove Tote Bag or Apply Free Shipping
                    console.log(total + ' step1 ' + step2)
                   
                    var gift_total = step2 - total; 
                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + gift_total + '</strong> to unlock your next surprise Gift</span>';
                    // $('.free-shipping .free-shipping__text').html(appendHtml);

                    if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) {
                        removeToteBag();
                    } 
                    if ($(document).find('[data-variant-id="44163889987879"]').length) {
                        removeToteBag();
                    } 
                    if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) {
                        removeSurpriseGift();
                    }
 /*------------------Step 3 Add Tote Bag and discount Calculation ------------------------*/
                } else if (total >= step2 && total <= step3) {
                    // Add Tote Bag Free
                    console.log(total + ' step2 ' + step3)

                    var discount_ = step3 - total;
                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + discount_ + '</strong> to unlock your next surprise</span>';
                    // $('.free-shipping .free-shipping__text').html(appendHtml);

                    if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) {
                      updateToteBag();
                    } else {
                      addToteBag();
                    }     
                    if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) {
                        removeSurpriseGift();
                    }
 /*------------------ Step 4 Discount apply and Surprise Gift Calculation ------------------------*/
               } else if (total >= step3 && total <= step4) {
                    console.log(total + ' step3 ' + step4)

                    // console.log('total <= step4 --> ' + total + ' - ' +step4);
                    var surprise = step4 - total;
                    
                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + surprise + '</strong> to unlock your next surprise</span>';
                    // $('.free-shipping .free-shipping__text').html(appendHtml);
                  
                    if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) {
                      updateToteBag();
                    } else {
                      addToteBag();
                    } 
                    if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) {
                        removeSurpriseGift();
                    }                   
 /*----------------------- Step 5 Final Add Surprise Product ------------------*/ 
                } else if (total > step4) {
                    console.log("step - 4 surprise");
                    if ($(document).find('.addProduct[data-variant-id="44163889987879"]').length) { 
                      updateToteBag(); 
                    } else {
                       addToteBag();
                    } 
                    if ($(document).find('.addProduct[data-variant-id="44163896410407"]').length) { 
                      updateSurpriseGift();
                     } else {
                       addSurpriseGift();
                    }
                } else { }
                $('body').addClass('progressDone');
          //  }
        }, 200);
      $('body').addClass('barDisconnect')
  }
}

  

var interval = self.setInterval(function(){shippingBarStatus()},3000);



  
    $(document).on('click', 'cart-drawer', function() {
 //        var cartDrawerShipping = $('form#cart .w-full.bg-washedGreen').html();
 //        $('main#MainContent .w-full.bg-washedGreen').html(cartDrawerShipping);
      
 //        var total = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total"));
 //        setTimeout(function() {
 //            var total = Number($(document).find('.mini-cart__footer .subtotal').attr("data-total")); 
 //            console.log(total);
 //           // if ($('body').hasClass('progressDone')) { } else {
 //                var step1 = Number($('.progress_steps span#step1').attr("data-shipping"));
 //                var step2 = Number($('.progress_steps span#step2').attr("data-gift"));
 //                var step3 = Number($('.progress_steps span#step3').attr("data-discount"));
 //                var step4 = Number($('.progress_steps span#step4').attr("data-surprise"));

 // /*-----------------------Step 1 - Free Shipping Calculation -------------------------------*/
 //                if (total <= step1) {
 //                    console.log(total + ' step1 ' + step1)
 //                    var productId = $(".gift_product-id").attr('id'); 
                  
 //                    var shipping_total = step1 - total;
 //                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add a hat <strong>' + shipping_total + '</strong> Gets free shipping added automatically</span>';
 //                    $('.free-shipping .free-shipping__text').html(appendHtml);
 //                    var x = (step1 * 100) / step4;
 //                    $('.progress_steps #step1').css("width", +25 + '%'); 
                  
 //                    if ($(document).find('.addProduct[data-variant-id="44034678784295"]').length) {
 //                         removeToteBag();
 //                    } 
 //                    if ($(document).find('.addProduct[data-variant-id="44031819972903"]').length) {
 //                         removeSurpriseGift();
 //                    }   
 // /*----------------------- Step 2 Apply Shipping and Bag Calculation ---------------------------------*/
 //                  } else if (total <= step2) {
 //                    // remove Tote Bag or Apply Free Shipping
 //                    console.log(total + ' step1 ' + step2)
                  
 //                    var gift_total = step2 - total; 
 //                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + gift_total + '</strong> to unlock your next surprise Gift</span>';
 //                    $('.free-shipping .free-shipping__text').html(appendHtml);

 //                    if ($(document).find('.addProduct[data-variant-id="44034678784295"]').length) {
 //                        removeToteBag();
 //                    } 
 //                    if ($(document).find('.addProduct[data-variant-id="44031819972903"]').length) {
 //                        removeSurpriseGift();
 //                    }
 // /*------------------Step 3 Add Tote Bag and discount Calculation ------------------------*/
 //                } else if (total >= step2 && total <= step3) {
 //                    // Add Tote Bag Free
 //                    console.log(total + ' step2 ' + step3)

 //                    var discount_ = step3 - total;
 //                    var appendHtml = '<span class="free-shipping__text" data-price="0">Add <strong>' + discount_ + '</strong> to unlock your next surprise</span>';
 //                    $('.free-shipping .free-shipping__text').html(appendHtml);

 //                    if ($(document).find('.addProduct[data-variant-id="44034678784295"]').length) {
 //                      updateToteBag();
 //                    } else {
 //                      addToteBag();
 //                    }     
 //                    if ($(document).find('.addProduct[data-variant-id="44031819972903"]').length) {
 //                        removeSurpriseGift();
 //                    }
 // /*------------------ Step 4 Discount apply and Surprise Gift Calculation ------------------------*/
 //               } else if (total >= step3 && total <= step4) {
 //                    console.log(total + ' step3 ' + step4)

 //                    // console.log('total <= step4 --> ' + total + ' - ' +step4);
 //                    var surprise = step4 - total;
 //                    $('.free-shipping__text').text('Add (' + surprise + ') to unlock your next surprise ');

 //                    if ($(document).find('.addProduct[data-variant-id="44034678784295"]').length) {
 //                      updateToteBag();
 //                    } else {
 //                      addToteBag();
 //                    } 
 //                    if ($(document).find('.addProduct[data-variant-id="44031819972903"]').length) {
 //                        removeSurpriseGift();
 //                    }                   
 // /*----------------------- Step 5 Final Add Surprise Product ------------------*/ 
 //                } else if (total > step4) {
 //                    console.log("step - 4 surprise");
 //                    if ($(document).find('.addProduct[data-variant-id="44034678784295"]').length) { 
 //                      updateToteBag(); 
 //                    } else {
 //                       addToteBag();
 //                    } 
 //                    if ($(document).find('.addProduct[data-variant-id="44031819972903"]').length) { 
 //                      updateSurpriseGift();
 //                     } else {
 //                       addSurpriseGift();
 //                    }
 //                } else { }
 //                $('body').addClass('progressDone');
 //          //  }
 //        }, 100);
    });
});
/*---Shipping progress End---*/